import { useMemo } from "react";
import ResetPasswordModal from "../components/Header/ResetPasswordModal";
import { useVisible } from "../../../utils/hooks/useVisible";

export const useResetPasswordModal = (user?: any) => {
    const { visible, close, open } = useVisible();

    const modal = useMemo(() => {
        return (
            <ResetPasswordModal
                isOpen={visible}
                close={close}
                user={user}
            />
        );
    }, [visible, close, user]);

    return { open, modal };
}
